import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';
import { WeeklyAdPage } from './pages/weekly-ad/weekly-ad';
import { WeeklyAdPageFull } from './pages/weekly-ad/weekly-ad.full';
import { WeeklyAdCommon } from './pages/weekly-ad/weekly-ad.common';
import { WeeklyAdData }from'./providers/weekly-ad-data';

//Export
export { WeeklyAdPage } from './pages/weekly-ad/weekly-ad';
export { WeeklyAdPageFull } from './pages/weekly-ad/weekly-ad.full';

@NgModule({
    imports: [
        IonicModule
    ],
    declarations: [
        WeeklyAdPage,
        WeeklyAdPageFull
    ],
    exports: [
        WeeklyAdPage,
        WeeklyAdPageFull
    ],
    bootstrap: [],
    entryComponents: [
        WeeklyAdPage,
        WeeklyAdPageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, WeeklyAdData, WeeklyAdCommon]
})
export class WeeklyAdModule{
	constructor(public pageRef: PageRef){
        this.pageRef.addCfgLinks([
            { component: WeeklyAdPage, fullComponent: WeeklyAdPageFull,  name: 'Weekly Ad', segment: 'weekly-ad' },
            { component: WeeklyAdPage, fullComponent: WeeklyAdPageFull,  name: 'Weekly Ad', segment: 'weekly-ad/:id/:pindex' }
        ]); 
	}
}


// WEBPACK FOOTER //
// ./src/modules/weekly-ad/weekly-ad.module.ts